
import React from "react";

const ACCENT = "#BEE362"; // your green
const NAVY = "#1A4564";   // your navy

// ✅ replace with your real image later
import imageSrc1 from "../../Images/who.png";

/* -------------------- Tiny inline icons (no libs) -------------------- */
const UsersIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <path
      d="M16 11c1.66 0 3-1.57 3-3.5S17.66 4 16 4s-3 1.57-3 3.5S14.34 11 16 11ZM8 11c1.66 0 3-1.57 3-3.5S9.66 4 8 4 5 5.57 5 7.5 6.34 11 8 11Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M8 13c-2.67 0-8 1.34-8 4v3h10v-3c0-1.06.37-2.04 1.02-2.87C10.14 13.49 9.02 13 8 13Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M16 13c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

const BriefcaseIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <path
      d="M9 6V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M4 8h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M2 13h20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const FactoryIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <path
      d="M3 21V10l6 3V10l6 3V8l6 3v10H3Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M7 21v-4M11 21v-4M15 21v-4M19 21v-4"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const ChatIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <path
      d="M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-5 4v-4H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M7 9h10M7 13h7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const TrendingUpIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className}>
    <path
      d="M3 17l6-6 4 4 7-7"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 8h6v6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* -------------------- Component -------------------- */

export default function Who({
  // NEW CONTENT ONLY (as you asked)
  badge = "FÜR WEN IST DAS?",
  h2 = "Für welche Unternehmen eignet sich KI-Automatisierung?",
  items = [
    { label: "KMU & Mittelstand", icon: UsersIcon },
    { label: "Agenturen & Dienstleister", icon: BriefcaseIcon },
    { label: "Handwerk & Industrie", icon: FactoryIcon },
    { label: "Beratungen", icon: ChatIcon },
    { label: "Wachstumsorientierte Unternehmen", icon: TrendingUpIcon },
  ],
  // image on LEFT (you will replace later)
  imageSrc = imageSrc1,
}) {
  return (
    <section className="w-[90%] 2xl:w-[70%] mx-auto bg-white">
      <div className="">
        <div className="relative overflow-hidden  rounded-[28px] bg-white ring-1 ring-black/10 shadow-[0_18px_70px_rgba(0,0,0,0.08)]">
          {/* soft background glows */}
          <div
            className="pointer-events-none absolute -left-48 -top-48 h-[520px] w-[520px] rounded-full blur-3xl opacity-30"
            style={{ background: ACCENT }}
          />
          <div
            className="pointer-events-none absolute -right-56 -bottom-56 h-[560px] w-[560px] rounded-full blur-3xl opacity-20"
            style={{ background: NAVY }}
          />

          <div className="relative grid gap-10 p-6 sm:p-10 lg:grid-cols-12 lg:gap-12">
            {/* LEFT: IMAGE */}
            <div className="lg:col-span-5">
              <div className="relative h-full overflow-hidden rounded-[26px] bg-[#F6F7F8] ring-1 ring-black/10">
                <img
                  src={imageSrc}
                  alt="Für wen ist das"
                  className=" object-cover h-full  "
                />
                {/* subtle overlay like modern cards */}
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-tr from-black/10 via-transparent to-transparent" />
              </div>
            </div>

            {/* RIGHT: CONTENT */}
            <div className="lg:col-span-7">
              <div className="flex items-center gap-3">
                <span
                  className="inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold"
                  style={{
                    background: "rgba(190,227,98,0.18)",
                    color: NAVY,
                    border: "1px solid rgba(26,69,100,0.15)",
                  }}
                >
                  {badge}
                </span>
              </div>

              <h2 className="mt-4 h2-mb h2-md h2-lg h2-2xl">
                {h2}
              </h2>

            <div className="mt-7 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">

                {items.map((it, idx) => {
                  const Icon = it.icon;
                  return (
                    <div
  key={idx}
  className={[
    "group flex items-center gap-4 rounded-2xl bg-white px-4 py-4 ring-1 ring-black/10 shadow-[0_12px_30px_rgba(0,0,0,0.06)] transition hover:-translate-y-0.5 hover:shadow-[0_18px_40px_rgba(0,0,0,0.09)]",
    idx === items.length - 1 ? "lg:col-span-2" : "",
  ].join(" ")}
>
                      <span
                        className="grid h-11 w-11 place-items-center rounded-2xl"
                        style={{
                          background:
                            "linear-gradient(180deg, rgba(190,227,98,0.35), rgba(190,227,98,0.12))",
                          border: "1px solid rgba(190,227,98,0.45)",
                        }}
                      >
                        <Icon className="h-6 w-6" style={{ color: NAVY }} />
                      </span>

                      <p className="text-[15px] font-semibold text-[#111827]">
                        {it.label}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* bottom accent line */}
          <div
            className="pointer-events-none absolute inset-x-0 bottom-0 h-px opacity-80"
            style={{
              background:
                "linear-gradient(90deg, transparent, rgba(190,227,98,0.85), transparent)",
            }}
          />
        </div>
      </div>
    </section>
  );
}
